import {TSyncStatus} from ".";

type TCrudMode = 'create' | 'read' | 'update' | 'delete';
type TRUMode = 'read' | 'update';

type TTabValue = 'basics' | 'configuration' | 'script'
